export class AssertUtil {

  public static unreachable(x: never): never {
    throw new Error(`unreachable statement.`);
  }
}
